//~~~~~~~~~~~~~~~~ Tushar 2025-08-28 Gid.:#1303 
import { Component, forwardRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isNullOrUndefined } from 'util';
import { ConfirmationHeader } from '../../common-services/enum.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-confirmation-table-popup',
  templateUrl: './confirmation-table-popup.component.html',
  styleUrls: ['./confirmation-table-popup.component.css']
})
export class ConfirmationTablePopupComponent implements OnInit {

  confirmation: NewConfirmationModel;
  buttonText = { ok: 'Ok', cancel: '' };
  constructor(public dialogRef: MatDialogRef<ConfirmationTablePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public _confModel: any,
  ) {
    this.confirmation = _confModel;
    if (isNullOrUndefined(this.confirmation.respObject)) {
      this.confirmation.respObject = true;
    }
    this.setButtonText(this.confirmation.buttonType);
  }

  ngOnInit() {
  }

  setButtonText(buttonType: ButtonType): any {
    switch (buttonType) {
      case ButtonType.Ok:
        this.buttonText = { ok: 'Ok', cancel: '' };
        break;
      case ButtonType.OkCancel:
        this.buttonText = { ok: 'Ok', cancel: 'Cancel' };
        break;
      case ButtonType.OkNoThanks:
        this.buttonText = { ok: 'Ok', cancel: 'No Thanks' };
        break;
      case ButtonType.YesNo:
        this.buttonText = { ok: 'Yes', cancel: 'No' };
        break;
      default:
        this.buttonText = { ok: 'Ok', cancel: '' };
        break;
    }
  }

  onOkClick() {
    if (isNullOrUndefined(this.confirmation.respObject)) {
      this.confirmation.respObject = true;
    }
    this.dialogRef.close(this.confirmation.respObject);
  }

  onCancelClick() {
    if (isNullOrUndefined(this.confirmation.respObject)) {
      this.confirmation.respObject = false;
    }
    this.dialogRef.close();
  }

  onexportClick() {
    debugger
    const exportData = this.confirmation.dataSource.filteredData.map(row => {
        const newRow: any = {};

        // Only take columns where isDisplay = true
        this.confirmation.tableObject.cellDefArray
          .filter(col => col.isDisplay)  // only displayed columns
          .forEach(col => {
            // only if the row has this field
            if (row.hasOwnProperty(col.tableFieldName)) {
              newRow[col.headerName] = row[col.tableFieldName];
            }
          });

        return newRow;
      });
debugger
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
      const workbook: XLSX.WorkBook = {
        Sheets: { 'Sheet1': worksheet },
        SheetNames: ['Sheet1']
      };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const data: Blob = new Blob([excelBuffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' 
      });

      FileSaver.saveAs(data, 'export.xlsx');
  }
}

export class NewConfirmationModel {
  public headerTitle: string;
  public message: string;
  public headerIcon: string;
  public headerBgColor: string;
  public fontColor: string;
  public buttonType: ButtonType;
  public respObject: any;
  public dataSource: any;
  public tableObject: any;
  public isExport: boolean;

  constructor(
    public _headerTitle: ConfirmationHeader,
    public _message: string,
    public _buttonType: ButtonType = ButtonType.YesNo,
    _respObject: any = true,
    _dataSource: any,
    _tableObject: any,
    _isExport: boolean = false
  ) {
    this.headerTitle = ConfirmationHeader[_headerTitle].toString();
    this.message = _message;
    this.buttonType = _buttonType;
    this.respObject = _respObject;
    this.dataSource = _dataSource;
    this.tableObject = _tableObject;
    this.isExport = _isExport;

    switch (_headerTitle) {
      case ConfirmationHeader.Confirmation:
        this.headerIcon = 'fa fa-question';
        this.headerBgColor = '#2196F3';
        this.fontColor = 'white';
        break;

      case ConfirmationHeader.Success:
        this.headerIcon = 'fa fa-check';
        this.headerBgColor = '#4CAF50';
        this.fontColor = 'white';
        break;

      case ConfirmationHeader.Notification:
        this.headerIcon = 'fa fa-info-circle';
        this.headerBgColor = '#00BCD4';
        this.fontColor = 'white';
        break;

      case ConfirmationHeader.Warning:
        this.headerIcon = 'fa fa-exclamation-triangle';
        this.headerBgColor = '#FF9800';
        this.fontColor = 'white';
        break;

      case ConfirmationHeader.Error:
        this.headerIcon = 'fa fa-exclamation-circle';
        this.headerBgColor = '#F44336';
        this.fontColor = 'white';
        break;

      default:
        this.headerIcon = 'fa fa-exclamation';
        this.headerBgColor = '#9E9E9E';
        this.fontColor = 'white';
        break;
    }
  }
}

export enum ButtonType {
  Ok = 0,
  OkCancel = 1,
  YesNo = 3,
  OkNoThanks = 1,
}
//~~~~~~~~~~~~~~~~ 2025-08-28 Gid.:#1303 